/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAppInsightsState } from './app-insights.state';

export const featureKey = 'appInsights';

const selectFeature = createFeatureSelector<IAppInsightsState>(featureKey);

export const selectLoading = createSelector(
    selectFeature,
    ({ loading }) => loading,
);

export const selectError = createSelector(
    selectFeature,
    ({ error }) => error,
);

export const selectAppInsightsByVs = createSelector(
    selectFeature,
    ({ appInsightsByVs }) => appInsightsByVs,
);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const selectAppInsightsByVsId = (vsId: string) => {
    return createSelector(
        selectAppInsightsByVs,
        appInsightsByVs => appInsightsByVs[vsId],
    );
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const selectAppInsightsUrisByVsId = (vsId: string) => {
    return createSelector(
        selectAppInsightsByVsId(vsId),
        appInsightsData => appInsightsData?.appInsights?.app_info?.uri,
    );
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const selectAppInsightsRespByVsId = (vsId: string) => {
    return createSelector(
        selectAppInsightsByVsId(vsId),
        appInsightsData => appInsightsData?.appInsights?.resp,
    );
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const selectAppInsightsLastModifiedByVsId = (vsId: string) => {
    return createSelector(
        selectAppInsightsByVsId(vsId),
        appInsightsData => appInsightsData?.lastUpdatedTimestamp,
    );
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const selectAppInsightsInitialLoadedByVsId = (vsId: string) => {
    return createSelector(
        selectAppInsightsByVsId(vsId),
        appInsightsData => Boolean(appInsightsData?.initialLoaded),
    );
};
